export default "__VITE_ASSET__D8dScz_r__"